module.exports = __webpack_public_path__ + "components/country-flag/static/my-27a2b417192620d1aa7cdad4fa8a5e8b.svg";